import type { EntityId } from '../shared'

export enum CoreCopayStatus {
  Pending = 'pending',
  Triage = 'triage',
  Rejected = 'rejected',
  Complete = 'completed',
}

export enum CopayStatus {
  Pending = 'Pending',
  Triage = 'Triage',
  PriorAuthorization = 'PriorAuthorization',
  Rejected = 'Rejected',
  Complete = 'Complete',
  Confirmed = 'Confirmed',
}

export enum CopayTriageReasons {
  AutomatedTransferPending = 'Automated Transfer Pending',
  ManualCouponRetrievalRequired = 'Manual Coupon Retrieval Required',
  ManualVerificationRequired = 'Manual Verification Required',
  BadInsuranceDetails = 'Bad Insurance Details',
  ClinicOutreach = 'Clinic Outreach',
  CoverageNotEffective = 'Coverage Not Effective',
  CoverageTerminated = 'Coverage Terminated',
  CustomerClarificationNeeded = 'Customer Clarification Needed',
  DateOfBirthMismatch = 'Date Of Birth Mismatch',
  DuplicateRequest = 'Duplicate Request',
  MedicarePaymentPlan_056 = 'MedicarePaymentPlan_056',
  MedicarePaymentPlan_057 = 'MedicarePaymentPlan_057',
  MedicarePaymentPlan_058 = 'MedicarePaymentPlan_058',
  MissingInvalidPrescriberZipPostalZone = 'Missing/Invalid Prescriber Zip/Postal Zone',
  NotCoveredByInsurance = 'Not Covered By Insurance',
  OutOfNetwork = 'Out Of Network',
  PendingInternalTransfer = 'Pending Internal Transfer',
  PlanLimitationsExceeded = 'Plan Limitations Exceeded',
  PrescriptionIssue = 'Prescription Issue',
  PriorAuthorizationNeeded = 'Prior Authorization Needed',
  RefillTooSoon = 'Refill Too Soon',
  ReviewRequired = 'Review Required',
  EVoucherNotAllowed = 'EVoucher Not Allowed',
  Other = 'Other',
}

export const MedicarePaymentPlanCopayTriages: string[] = [
  CopayTriageReasons.MedicarePaymentPlan_056,
  CopayTriageReasons.MedicarePaymentPlan_057,
  CopayTriageReasons.MedicarePaymentPlan_058,
]

export enum CopayTriageOtherReasonMessages {
  FailedReversalTriageReason = 'Failed to reverse claim, manual reversal and rejection required',
  FailedReversalAfterMinutesTriageReason = 'Failed to reverse claim after \\d minutes, manual reversal and rejection required',
}

export enum CopayTriageCodes {
  BadInsuranceDetails = 'CT010',
  ClinicOutreach = 'CT001',
  CoverageNotEffective = 'CT008',
  CoverageTerminated = 'CT007',
  CustomerClarificationNeeded = 'CT002',
  DateOfBirthMismatch = 'CT009',
  DuplicateRequest = 'CT013',
  ManualCouponRetrievalRequired = 'CT024',
  ManualVerificationRequired = 'CT020',
  AutomatedTransferPending = 'CT021',
  MedicarePaymentPlan_056 = 'CT014',
  MedicarePaymentPlan_057 = 'CT015',
  MedicarePaymentPlan_058 = 'CT016',
  MissingInvalidPrescriberZipPostalZone = 'CT022',
  NotCoveredByInsurance = 'CT017',
  OutOfNetwork = 'CT018',
  PendingInternalTransfer = 'CT005',
  PlanLimitationsExceeded = 'CT012',
  PrescriptionIssue = 'CT019',
  PriorAuthorizationNeeded = 'CT003',
  RefillTooSoon = 'CT004',
  ReviewRequired = 'CT011',
  EVoucherNotAllowed = 'CT023',
  Other = 'CT006',
}

export interface ApprovedCopay {
  approvedDate: Date
  copayAmount: number
}

export type CancelOpenCopayRequestReason = 'OTHER' | 'DUPLICATE'

export interface CopayTriage {
  _id: EntityId
  code: string
  copayRequestFillId?: EntityId
  endDate?: Date
  fillId?: EntityId
  message?: string
  reason: string
  startDate: Date
  userPlacedInTriage: EntityId
  userRemovedFromTriage?: EntityId
}

export interface CopayRequestStatusUpdate {
  'copayRequestFills.$.status': CopayStatus
  'copayRequestFills.$.triages'?: CopayTriage[]
}
